/**
 * Attach the standard 401-handling response interceptor to an axios instance.
 *
 * On a 401 (session expired/revoked) it clears the stored session and bounces to
 * /login — exactly what the 23 feature services already do. The analytics and
 * report services each created their own axios instance WITHOUT this, so a session
 * expiry on those screens left the user stranded on a dead page (inline error, no
 * auto-logout). Using one shared implementation keeps every endpoint consistent.
 */
export function attachAuthInterceptor(apiInstance) {
  apiInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('access_token');
        localStorage.removeItem('user_data');
        sessionStorage.removeItem('auth_token');
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('user_data');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
  return apiInstance;
}

export default attachAuthInterceptor;
